// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2177":"b2edec62","2304":"72207386","3651":"5e658fe5","6314":"72207386","6824":"66b28655","7171":"15783d8d","7637":"ba918bc0","8754":"b2edec62","9849":"77568719"}[chunkId] + ".chunk.css";
};